module.exports = __webpack_public_path__ + "img/ctm-check-circle.93fd34c9.svg";